import * as Sentry from "@sentry/react"
import { createRoot } from "react-dom/client"
import App from "./App.tsx"
import "./index.css"
import Clarity from "@microsoft/clarity"
import ReactGA from "react-ga4"
import { AuthProvider } from "./modules/Auth/context/AuthContext.tsx"
import { ToastProvider } from "./contexts/ToastContext"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

ReactGA.initialize("G-21LFSM5TXR")

const projectId = "wwo18odswd"

Clarity.init(projectId)

createRoot(document.getElementById("root")!).render(
  <ToastProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ToastProvider>
)
